// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"7d8ad6a0","94":"c36e3b85","118":"8742e501","152":"f926abd0","488":"fc32fdd6","521":"a86f7c4e","620":"895ea007","629":"62cb14d5","746":"3dec48ae","835":"63508c91"}[chunkId] + ".chunk.js";
};